import { usePathMatchIndex } from '@features/auth/hooks';
import { AuthStepper } from '@features/auth/registration/components/Common/AuthStepper';
import { useAppbarTitle } from '@hooks/useAppbarTitle';
import { usePageTitle } from '@hooks/usePageTitle';
import { useTranslation } from 'react-i18next';

const steps = ['packages', 'terms', 'payment'];

export function MonitoringRequestLayout() {
	const { t } = useTranslation();
	usePageTitle(t('services'));
	useAppbarTitle(t('monitoring'));
	const activeStepIndex = usePathMatchIndex(steps);

	return <AuthStepper hFull activeStepIndex={activeStepIndex} steps={steps} />;
}
